import ContractViewer from './ContractViewer';

export default ContractViewer;
